import React from 'react';
import {microreelsListText} from '../microreelsListText';
import MicroreelCardOptions from './MicroreelCardOptions';
import styles from './MicroreelsGeneratingCard.module.css';

const REELS = [0, 1, 2];

interface Props {
  title?: string;
  onOpen: () => void;
  onCancel?: () => void;
}

const MicroreelsGeneratingCard = React.memo(
  ({title, onOpen, onCancel}: Props) => {
    return (
      <div className={styles.cardContainer}>
        <div
          className={styles.card}
          role="button"
          tabIndex={0}
          onClick={onOpen}
          onKeyDown={ev => {
            if (ev.key === 'Enter' || ev.key === ' ') {
              ev.preventDefault();
              onOpen();
            }
          }}>
          <div className={styles.cover}>
            <div className={styles.reels}>
              {REELS.map(reel => (
                <span key={reel} className={styles.reel} />
              ))}
            </div>
          </div>
          <div className={styles.statusContainer}>
            <span className={styles.statusTitle}>
              {microreelsListText.generating}
            </span>
            {title && <span className={styles.statusName}>{title}</span>}
            <span className={styles.statusText}>
              {microreelsListText.generatingHint}
            </span>
            <span className={styles.progressTrack}>
              <span className={styles.progressBar} />
            </span>
          </div>
          {onCancel && (
            <div
              className={styles.optionsPosition}
              onClick={ev => ev.stopPropagation()}>
              <MicroreelCardOptions
                options={[
                  {
                    label: microreelsListText.cancelGeneration,
                    onClick: onCancel,
                    danger: true,
                  },
                ]}
              />
            </div>
          )}
        </div>
      </div>
    );
  },
);

export default MicroreelsGeneratingCard;
